import axios from 'axios';
import { createSharedSession } from './sharedSession';

import { API_URL, BASE_PATH, AUTH_TOKEN_KEY, AUTH_USER_KEY } from './siteConfig';
export { BASE_PATH };
export const sharedSession = createSharedSession('social');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(async (config) => {
  if (!config.skipSharedRestore && (!config.url?.startsWith('/auth/') || config.url === '/auth/me')) await sharedSession.restore().catch(() => {});
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  config.sharedAuthToken = token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = error.config?.sharedAuthToken;
    const isCredentialRequest = ['/auth/login', '/auth/register'].includes(error.config?.url);
    if (error.response?.status === 401 && token && !isCredentialRequest && token === localStorage.getItem(AUTH_TOKEN_KEY)) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      localStorage.removeItem(AUTH_USER_KEY);
      const loginPath = `${BASE_PATH}/login`;
      if (window.location.pathname.replace(/\/+$/, '') !== loginPath) window.location.href = loginPath;
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const login = (credentials) => api.post('/auth/login', credentials);
export const register = (userData) => api.post('/auth/register', userData);
export const getCurrentUser = (config) => api.get('/auth/me', config);

// Skills APIs
export const getSkills = (userId) => api.get(userId ? `/skills/${userId}` : '/skills');
export const getSkillsHistory = (userId) => api.get(userId ? `/skills/history/${userId}` : '/skills/history');
export const getLeaderboard = (skillName) => api.get(skillName ? `/skills/leaderboard/${skillName}` : '/skills/leaderboard');

export default api;
